import React from "react";

const HomeIcon = ({ color = "#122549" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.47379 22.2091H8.72031V13.6373H15.2799V22.2091H20.5264V9.09787L12.0001 2.4869L3.47379 9.09787V22.2091ZM2.05273 23.6659V8.36947L12.0001 0.665894L21.9475 8.36947V23.6659H13.8588V15.0941H10.1414V23.6659H2.05273Z"
        fill={color}
      />
    </svg>
  );
};

export default HomeIcon;
